import { render, staticRenderFns } from "./login-account.vue?vue&type=template&id=40425b99&scoped=true"
import script from "./login-account.vue?vue&type=script&lang=js"
export * from "./login-account.vue?vue&type=script&lang=js"
import style0 from "./login-account.vue?vue&type=style&index=0&id=40425b99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../A8/pc/node_modules/.pnpm/vue-loader@15.11.1_@vue+com_5bba9927a18eaff02a55b79fc72fdde2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40425b99",
  null
  
)

export default component.exports